import { render, staticRenderFns } from "./payment2.vue?vue&type=template&id=39693f15&"
import script from "./payment2.vue?vue&type=script&lang=js&"
export * from "./payment2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports